import styled from "styled-components";

export const ContainerSelectFinancialInstallmentsModal = styled.div`
  label {
    color: #9074bf;
    font-size: 14px;
    font-weight: bold;
  }
`;
